import { approveStatusREC1, approveStatusREC2 } from '../../../constants/approveStatus'
import * as Constants from '../../../constants/constants'
import constSubmittedType from '../../../constants/submittedType'
import * as RESServiceType from '../../../services/web/types/responseWebServiceTypes'
const useProjectHook = () => {
    const isEditAfterReview = (
        projectInfo:
            | Partial<Pick<RESServiceType.GetProjectResultType, 'aroundSubmittedIDInfo' | 'submitTypeInfo'>>
            | undefined,
    ) => {
        let isFlowEditAfterReview = false
        const hasPreviousFolder: boolean = projectInfo?.aroundSubmittedIDInfo?.previousSubmittedID !== null //มี Folder ก่อนหน้า
        const isSubmittedTypeNewProject: boolean =
            constSubmittedType.firstSubmitConsideration === projectInfo?.submitTypeInfo?.value //ยื่นโครงการใหม่
        const isSubmittedTypeEditAfterReview: boolean =
            constSubmittedType.editAfterReview === projectInfo?.submitTypeInfo?.value //แก้ไขหลังพิจารณา

        if (hasPreviousFolder && (isSubmittedTypeNewProject || isSubmittedTypeEditAfterReview)) {
            isFlowEditAfterReview = true
        }

        return isFlowEditAfterReview
    }

    const isSynthesisApproveWithComment = (
        projectInfo: Partial<Pick<RESServiceType.GetProjectResultType, 'synthesisApproveStatusInfo'>> | undefined,
    ) => {
        const isAWC: boolean =
            approveStatusREC1.approveWithComment === projectInfo?.synthesisApproveStatusInfo?.value ||
            approveStatusREC2.approveWithComment === projectInfo?.synthesisApproveStatusInfo?.value

        return isAWC
    }

    const isFlowApproveWithComment = (
        projectInfo: Partial<Pick<RESServiceType.GetProjectResultType, 'isFlowApproveWithComment'>> | undefined,
    ) => {
        return projectInfo?.isFlowApproveWithComment ?? false
    }

    return {
        isEditAfterReview,
        isSynthesisApproveWithComment,
        isFlowApproveWithComment,
    }
}

export default useProjectHook
